module.exports = __webpack_public_path__ + "e2bd81f734c934f677c1879b6bfa19ba.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/july-sale-banner.png
// module id = 306
// module chunks = 0